import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();

function Lang() {
  if (getLanguageByPath() === 'zh-Hant') {
    return 'tc';
  } else {
    return getLanguageByPath();
  }
}

//console.log(pageLocalesData, 'pageLocalesData.mecha_unit *********');

/**
 *  特装机甲数据
 */
export const mechaData = {
  basicInformation: pageLocalesData.mecha_unit.mecha_baseInfo_title,
  roleExperience: pageLocalesData.mecha_unit.falcon.driver_role_title,
  driverVoice: pageLocalesData.mecha_unit.driver_cv_title,
  mecha_story_tips: pageLocalesData.mecha_unit.mecha_story_title,
  manufacturer: pageLocalesData.mecha_unit.mecha_factory_title,
  //  矛隼
  bg: toWebpImage(require(`./images/${Lang()}/bg.jpg`)),
  mecha_title_img: toWebpImage(require(`./images/${Lang()}/title.png`)),
  
  
  mechaName_img: toWebpImage(require(`./images/${Lang()}/mechaName.png`)),
  driverName_img: toWebpImage(require(`./images/${Lang()}/driverName.png`)),
  familyCrest_img: toWebpImage(require(`./images/${Lang()}/familyCrest.png`)),
  driverBg: toWebpImage(require(`./images/${Lang()}/bg-line-driver.png`)),
  mechaBg: toWebpImage(require(`./images/${Lang()}/bg-line-mecha.png`)),
  cvItemActive: toWebpImage(require(`./images/${Lang()}/cv-active-bg.png`)),
  cvItem: toWebpImage(require(`./images/${Lang()}/cv-bg.png`)),
  cvcvAudioPause: toWebpImage(require(`./images/${Lang()}/cv-pause.png`)),
  cvcvAudioPlay: toWebpImage(require(`./images/${Lang()}/cv-play.png`)),
  cvTabBox: toWebpImage(require(`./images/${Lang()}/cv-title-bg.png`)),
  cvTabBtnActive: toWebpImage(require(`./images/${Lang()}/cvTabBtnActive.png`)),
  cvTitleIcon: toWebpImage(require(`./images/${Lang()}/cvTitle-icon.png`)),
  driverActiveBtn: toWebpImage(require(`./images/${Lang()}/driver-active-btn.png`)),
  driverBtn: toWebpImage(require(`./images/${Lang()}/driver-btn.png`)),
  gotoTOPbg: toWebpImage(require(`./images/${Lang()}/gotoTOPbg.png`)),
  group_logo: toWebpImage(require(`./images/${Lang()}/group-logo.png`)),
  manufacturerIcon: toWebpImage(require(`./images/${Lang()}/manufacturer-icon.png`)),
  mechaActiveBtn: toWebpImage(require(`./images/${Lang()}/mecha-active-btn.png`)),
  mechaBtn: toWebpImage(require(`./images/${Lang()}/mecha-btn.png`)),
    
  returnBtn: toWebpImage(require(`./images/${Lang()}/returnBtn.png`)),
  titleIcon: toWebpImage(require(`./images/${Lang()}/title-icon.png`)),
  goTopBtn: toWebpImage(require(`./images/${Lang()}/top.png`)),
  triangle_icon: toWebpImage(require(`./images/${Lang()}/triangle-icon.png`)),
  triangleIcon: toWebpImage(require(`./images/${Lang()}/triangleIcon.png`)),
  
  videoBtn: toWebpImage(require(`./images/${Lang()}/video-btn.png`)),
  driver_sex: pageLocalesData.mecha_unit.falcon.driver_sex,
  driver_birth_place: pageLocalesData.mecha_unit.falcon.driver_birth_place,
  driver_mecha_name: pageLocalesData.mecha_unit.falcon.driver_mecha_name,
  driver_role_desc: pageLocalesData.mecha_unit.falcon.driver_role_desc,
  mecha_number: pageLocalesData.mecha_unit.falcon.mecha_number,
  mecha_head_height: pageLocalesData.mecha_unit.falcon.mecha_head_height,
  mecha_empty_weight: pageLocalesData.mecha_unit.falcon.mecha_empty_weight,
  mecha_full_weight: pageLocalesData.mecha_unit.falcon.mecha_full_weight,
  mecha_story_desc: pageLocalesData.mecha_unit.falcon.mecha_story_desc,
  mecha_factory_name: pageLocalesData.mecha_unit.falcon.mecha_factory_name,
  video_link:
    Lang() === 'ja'
      ? 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1751299540423_FALCON_ELITE_PV_4k_jp.mp4'
      : 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1751299540423_FALCON_ELITE_PV_4k_en.mp4',
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254409435_1-Vox_Pilot_Get_Elite_LeonieFevre.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254409435_2-Vox_Pilot_Entrance_Elite_LeonieFevre_a.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254409435_3-Vox_Pilot_MVP_Elite_LeonieFevre_a.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254367103_1-Vox_Pilot_Get_Elite_LeonieFevre.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254367103_2-Vox_Pilot_Entrance_Elite_LeonieFevre_a.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254367103_3-Vox_Pilot_MVP_Elite_LeonieFevre_a.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254239846_1-Vox_Pilot_Get_Elite_LeonieFevre.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254239846_2-Vox_Pilot_Entrance_Elite_LeonieFevre_a.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254239846_3-Vox_Pilot_MVP_Elite_LeonieFevre_a.wav',
      phrase: pageLocalesData.mecha_unit.falcon.phrase3,
      isPlay: false
    }
  ]
  ,
};
